import { CONNECT_SUCCESS } from '../actions';

const INIT_STATE = {
  newConnection: undefined,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONNECT_SUCCESS:
      return { ...state, newConnection: action.payload };
    default:
      return { ...state };
  }
};
